import Logger from './utils/Logger';
import Pair from './Pair';
import Room from './Room';
import Base64 from './utils/Base64';
import Stream from './Stream';
import config from './../Common.config';
import { RoomEvent, StreamEvent, PublisherEvent } from './Events';

import customErrors from './customErrors';
import vcxEventProperties from './vcxEventProperties';
import EL from './EventLogger';
import customEvents from './customEvents';

const constants = vcxEventProperties.constant;

/*
 *   Author: Avnish
 *   Description: Merge all method in a singel class
 */
const VcxQuickApi = {};
VcxQuickApi.default = {
  minVideoBW: 80,
  maxVideoBW: 1500,
  scheme: 'notify-break-recover',
};

//////////disconnect Room///////////////
VcxQuickApi.disconnectRoom = (room) => {
  if (room) {
    room.disconnect();
  }
};

/////////Get Device List//////////////
VcxQuickApi.getDevice = (callback) => {
  if(typeof callback === 'function'){
    if (!config.is_supported()) {
      Logger.info('Failed Webrtc support is missing ');
      callback(customErrors.error_1000);
      return;
    }
    Pair.getDeviceList(callback);
  }
  else{
    Logger.error('getDevice() invalid param - callback');
  }
};

VcxQuickApi.notifyDeviceUpdate = (roomHandle) => {
  if (!config.is_supported()) {
    Logger.info('Failed Webrtc support is missing ');
    return;
  }
  roomHandle.notifyDeviceUpdate();
};

VcxQuickApi.switchMediaDevice = (stream, audioDeviceId, videoDeviceId, callback = () => { }) => {
  if (typeof callback === 'function') {
    if (!config.is_supported()) {
      Logger.info('Failed Webrtc support is missing ');
      callback(customErrors.error_1000);
      return;
    }

    if ((audioDeviceId && typeof audioDeviceId === 'string') && (videoDeviceId && typeof videoDeviceId === 'string')) {
      stream.switchMediaDevices(stream, audioDeviceId, videoDeviceId, callback);
    } else {
      Logger.info('Invalid Device Id');
      callback(false);
    }
  }
  else {
    Logger.error('switchMediaDevice() invalid param - callback');
  }


};

///////////Join Room/////////////
VcxQuickApi.joinRoom = (token, streamInfo, callback, reconnectInfo = { allow_reconnect: true, number_of_attempts: 3, timeout_interval: 45000 }) => {
  if (!config.is_supported()) {
    Logger.info('Failed Webrtc support is missing ');
    callback(null, customErrors.error_1000);
    return;
  }

  let room;
  let localStream;
  let error = null;
  let success = null;
  Logger.info(`SDK version: ${config.product.version} browser name: ${config.browser_type} browser version: ${config.browser_info.version} device type: ${config.browser_info.device_type}`);

  if (token != null) {
    const tok = JSON.parse(Base64.decodeBase64(token));
    //var tok = JSON.parse(window.atob(token));
    EL.init(tok);
    tok.version = config.product.version;
    //room = Room(undefined, undefined, { token: window.btoa(JSON.stringify(tok)),reconnectInfo });
    room = Room(undefined, undefined, { token: Base64.encodeBase64(JSON.stringify(tok)), reconnectInfo });
    const onAccessSuccess = () => {
      if (Pair.browserEngineCheck() !== 'IE') {
        room.addEventListener('room-connected', (streamEvent) => {
          success = {
            streams: streamEvent.streams,
            room,
            roomData: streamEvent.room,
            localStream,
          };
          let pubOps;
          if (streamEvent.me !== undefined && streamEvent.me !== null && (room.mode !== 'lecture' ||
            streamEvent.me.role !== 'participant' || room.floorGranted) &&
            (streamInfo.audio || streamInfo.video)) {
            pubOps = {};
            if (streamInfo.maxVideoBW) {
              pubOps.maxVideoBW = streamInfo.maxVideoBW;
            }

            if (streamInfo.minVideoBW) {
              pubOps.minVideoBW = streamInfo.minVideoBW;
            }

            if (streamInfo.maxVideoFps) {
              pubOps.maxVideoFps = streamInfo.maxVideoFps;
            }

            if (streamInfo.maxVideoFps) {
              pubOps.maxVideoFps = streamInfo.maxVideoFps;
            }

            if (streamInfo.audioMuted) {
              pubOps.audioMuted = streamInfo.audioMuted;
            }

            if (streamInfo.videoMuted) {
              pubOps.videoMuted = streamInfo.videoMuted;
            }

            pubOps.scheme = streamInfo.scheme ? streamInfo.scheme : VcxQuickApi.default.scheme;
            pubOps.maxVideoLayers = room.maxVideoLayers;
            //pubOps.maxVideoLayers = streamInfo.maxVideoLayers;
            pubOps.forceTurn = streamInfo.forceTurn;
          }

          if (room.reconnectionState === false) {
            if (streamInfo.video && room.subscription && !room.subscription.audio_video) {
              Logger.error('Licence error : video not supported, ignoring video option');
              streamInfo.video = false;
            }

            if (streamInfo.audio && room.subscription && !room.subscription.audio_only && !room.subscription.audio_video) {
              Logger.error('Licence error : audio not supported, ignoring audio option');
              streamInfo.audio = false;
            }

            const publishStream = (ops, callback) => {
              let resp;
              room.publish(localStream, ops, (response) => {
                if (response.result === 0) {
                  success.publishId = response.id;
                  if (room.mediaConfiguration !== constants.H264_CODEC && config.browser_info.name === 'safari' && config.browser_info.version <= constants.SAFARI_VERSION_NOT_SUPPORTING_VP8) {
                    callback(success, customErrors.error_1152);
                  } else {
                    callback(success, null);
                  }

                  if (streamEvent.mediaRecord) {
                    room.dispatchEvent(RoomEvent({ type: 'room-record-on', message: {} }));
                  }

                  if (streamEvent.room.mute) {
                    room.dispatchEvent(RoomEvent({ type: 'room-muted', message: {} }));
                  }
                } else if (response.result === customErrors.error_1130.result) {
                  callback(success, response);
                } else {
                  callback(null, response);
                }
              });
            };

            if (pubOps != undefined && room.waitRoom === false) {
              publishStream(pubOps, callback);
            } else if (room.waitRoom) {
              /*room.dispatchEvent(RoomEvent({ type: 'room-awaited', message}));*/
              callback(success, null);
              room.addEventListener('wait-room-disabled', (arg) => {
                room.dispatchEvent(RoomEvent({ type: 'room-allowed', message: arg.message }));
                if (room.mode !== 'lecture')
                  publishStream(pubOps, callback);
              });
            } else {
              Logger.info(`No publish -${!streamInfo.audio && !streamInfo.video}` ? 'no audio&video' : 'lecture mode publisher');
              callback(success, null);
            }
          } else {
            Logger.info('handle reconnection: for room-connected ');
            // subcribe all remote streams and show them accrodingly in player
            success = {
              streams: streamEvent.streams,
              room,
              roomData: streamEvent.room,
              localStream,
            };

            for (let i = 0; i < success.streams.length; i++) {
              const optionsInput = {};
              room.subscribe(success.streams[i], optionsInput, (res) => {
                // check if all the streams subscribed properly and flag that subscribed streams are fine
                if (res === true) {
                  Logger.info('reconnect subscriber callback success');
                } else {
                  Logger.info('reconnect subscriber callback failed, could not reconnect', res);
                  room.reconPubSubFailed(res);
                  room.dispatchEvent(RoomEvent({ type: 'room-error', message: res }));
                  EL.error(
                    'api-event', customEvents.event_reconnect_subscribe_failed,
                    { error: 'reconnect subscriber callback failed, couldnt reconnect', message: res },
                  );
                }
              });
            }

            // publish all local streams
            const publishAllStreams = (ops) => {
              // for all previous published local streams publish them and update the localstreams map
              room.localStreamsBeforeReconnect.forEach((localStream, id) => {
                if ((localStream.canvas === undefined) && (localStream.screen === undefined)) {
                  Logger.info(' reconnect publish, audio video data stream');
                  room.localStreamsBeforeReconnect.remove(id);
                  room.publish(localStream, pubOps, (response) => {
                    if (response.result === 0) {
                      success.publishId = response.id;
                      Logger.info('reconnected and stream published successfully');
                      room.manageStatsSubscription(localStream);
                      room.manageRecordingStatus();

                      if (streamEvent.mediaRecord) {
                        room.dispatchEvent(RoomEvent({ type: 'room-record-on', message: {} }));
                      }

                      if (streamEvent.room.mute) {
                        room.dispatchEvent({ type: 'room-muted', message: {} });
                      }

                      if (localStream.selfMuteAudio === true) {
                        localStream.sendEvent('user-audio-muted');
                      }

                      if (localStream.selfMuteVideo == true) {
                        localStream.sendEvent('user-video-muted');
                      }

                      // ugly hack for fixing ATVAV restriction at server side
                      // server says first published stream can not be canvas or share
                      room.localStreamsBeforeReconnect.forEach((localStream, id) => {
                        if (localStream.canvas === true) {
                          // publish canvas stream , may be to set specific config params like bandwidth etc
                          Logger.info(' reconnect publish, canvas stream');
                          room.localStreamsBeforeReconnect.remove(id);
                          room.publish(localStream, { maxVideoBW: 4096, minVideoBW: 1024 }, (response) => {
                            if (response.result === 0) {
                              success.publishId = response.id;
                            } else {
                              Logger.info(' reconnect publish failed forcanvas stream failed', response);
                              room.reconPubSubFailed(response);
                              room.dispatchEvent(RoomEvent({ type: 'room-error', message: response }));
                              EL.error(
                                'api-event', customEvents.event_reconnect_publish_failed,
                                { error: 'reconnect publish for canvas stream failed', message: response },
                              );
                            }
                          });
                        } else if (localStream.screen === true) {
                          // publish share stream , may  to set specific config params like bandwidth etc
                          Logger.info(' reconnect publish, share stream');
                          room.localStreamsBeforeReconnect.remove(id);
                          room.publish(localStream, { share: true }, (response) => {
                            Logger.info(' reconnect publish response for share stream', response);
                            // do additional stuff
                            if (response.result === 0) {
                              Logger.info(' reconnect publish share successful', response);
                              room.localStreams.forEach((stream, id) => {
                                if (stream && stream.ifVideo()) {
                                  stream.setQualityLayers(2);
                                }
                              });
                              //   createEventLog('clientStreamShareSuccess', additionalOptions);
                            } else {
                              Logger.info(' reconnect publish share failed with reason', response);
                              room.reconPubSubFailed(response);
                              room.dispatchEvent(RoomEvent({ type: 'room-error', message: response }));
                              EL.error(
                                'api-event', customEvents.event_reconnect_publish_failed,
                                { error: 'reconnect publish share failed with reason', message: response },
                              );
                            }
                          });
                        } else {
                          Logger.info(' unknown stream type ????????????');
                        }
                      });
                    } else {
                      Logger.info(' reconnect publishing failed, response for publish', response);
                      room.reconPubSubFailed(response);
                      room.dispatchEvent(RoomEvent({ type: 'room-error', message: response }));
                      EL.error(
                        'api-event', customEvents.event_reconnect_publish_failed,
                        { error: 'reconnect publishing failed, response for publish', message: response },
                      );
                    }
                  });
                }
              });
            };

            if (pubOps != undefined && room.waitRoom === false && (room.mode !== 'lecture' || room.me.role === 'moderator')) {
              publishAllStreams(pubOps);
            } else if (room.waitRoom) {
              Logger.info('Reconnect WaitRoom on no publish');
              room.addEventListener('wait-room-disabled', (arg) => {
                if (room.mode !== 'lecture')
                  publishAllStreams(pubOps);
              });
            } else if (room.mode === 'lecture' && room.me.role !== 'moderator') {
              Logger.info(' reconnection:: No publish - participant in lecture mode');
              if (room.floorGranted) {
                room.floorGranted = false;
                room.dispatchEvent(RoomEvent({ type: 'release-floor', users: { clientId: room.clientId } }));
              }
            } else {
              Logger.info(` reconnection:: No publish -${!streamInfo.audio && !streamInfo.video}` ? 'no audio&video' : 'lecture mode publisher');
            }

            // consider reconnection successfull , handle only when all subscribed and published
            Logger.debug(' setting reconnection state as false ');
            room.reconnectionState = false;
            // reset the preferred number of active talkers
            room.manageNumTalker();
            // Send reconnected event
            Logger.info('send network reconnected event');
            const networkReconnected = RoomEvent({ type: 'network-reconnected', error: customErrors.error_1164.result, message: customErrors.error_1164.error });
            room.dispatchEvent(networkReconnected);
            // end dispatching the event
          }
        });

        room.addEventListener('room-error', (err) => {
          callback(success, err);
        });

        room.addEventListener('stream-added', (streamEvent) => {
          room.subscribe(streamEvent.stream);
        });

        room.addEventListener('active-talkers-updated', (event) => {
          const activeList = event.message.activeList;
          const activeListLength = activeList.length;
          if (activeListLength > 0) {
            for (let index = 0; index < activeListLength; index++) {
              if (activeList[index].mediatype === 'audio' && activeList[index].muteDueToBw === true) {
                room.remoteStreams.getAll()[activeList[index].streamId].audioOnly = true;
                const userMutedEvt = RoomEvent({
                  type: 'user-muted-due-to-bw-crunch',
                  message: {
                    streamId: activeList[index].streamId,
                    clientId: activeList[index].clientId,
                    name: activeList[index].name,
                  },
                });
                room.dispatchEvent(userMutedEvt);
              }
            }
          }
        });
      }

      if (room.reconnectionState === false && room.reconnectAttempt == 0) {
        room.connect(reconnectInfo);
      } else {
        Logger.debug(' Reconnection case in join room public api');
      }
    };

    const onAccessError = (err) => {
      error = err;
      callback(success, error);
    };

    if (streamInfo.audio || streamInfo.video) {
      localStream = room.initPublishStream(streamInfo.div, streamInfo, onAccessSuccess, onAccessError);
    } else {
      Logger.info(' No publish stream. audio and video are disabled..');
      onAccessSuccess();
    }
  }
  return localStream;
};

////////////////List Participants/////////////////
VcxQuickApi.listParticipants = (room) => {
  if (!config.is_supported()) {
    console.log('Failed Webrtc support is missing ');
    return;
  }
  let users = [];
  if (room) {
    users = room.userList;
  }
  return users;
};

const socketEventToArgs = (func, event) => {
  if (event.args) {
    func(...event.args);
  } else {
    func();
  }
};

////////////////ReceiveMessage/////////////////
VcxQuickApi.ReceiveMessage = (stream, div) => {
  if (stream) {
    stream.addEventListener('stream-data', (evt) => {
    });
  }
};

////////////////Send Message/////////////////
VcxQuickApi.sendMessage = (stream, data) => {
  if (stream) {
    stream.sendData(data);
  }
};

export default VcxQuickApi;



//////////////////
// WEBPACK FOOTER
// ./src/VcxQuickApi.js
// module id = 204
// module chunks = 0